import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { environment } from '@env';
import { translate, TRANSLOCO_SCOPE } from '@ngneat/transloco';
import { Store } from '@ngrx/store';
import { BehaviorSubject, filter, Subject, takeUntil } from 'rxjs';
import { CommonUtilsService } from '../../services/commonutils/common-utils.service';
import { TableColumn } from '../../interface/table-column.interface';
import { TableData } from '../../interface/table-data.interface';
import { TableRecordAction } from '../../interface/table-record-action.interface';
import { UtilsService } from '../../services/utils/utils.service';

import { GetInstanceDownloadableFiles } from '../../store/actions';
import { getInstanceDownloadableFiles$ } from '../../store/selectors';

@Component({
    selector: 'app-download-files-dialog',
    templateUrl: './download-files-dialog.component.html',
    styleUrls: ['./download-files-dialog.component.scss'],
    providers: [
        {
            provide: TRANSLOCO_SCOPE,
            useValue: '',
        },
    ],
    standalone: false,
})
export class DownloadFilesDialogComponent implements OnDestroy, OnInit {
    @Input() public instanceId: string;

    private unSubscribe = new Subject<void>();
    public files: any[] = [];
    public allColumns: BehaviorSubject<TableColumn[]> = new BehaviorSubject([
        {
            name: translate('Created By'),
            type: 'text',
            icon: undefined,
            id: 'createdBy',
            hideInAllColumnsList: false,
            hide: false,
        },
        {
            name: translate('Download'),
            type: 'link',
            icon: undefined,
            id: 'fileName',
            hideInAllColumnsList: false,
            hide: false,
        },
        {
            name: translate('Created On'),
            type: 'text',
            icon: undefined,
            id: 'createOn',
            hideInAllColumnsList: false,
            hide: false,
        },
        {
            name: translate('Check Sum'),
            type: 'ACTIONS',
            icon: undefined,
            id: 'checkSum',
            hideInAllColumnsList: false,
            hide: false,
        },
    ]);
    public recordActions: TableRecordAction[] = [];
    public selectedFileUploadColumns: string[] = ['createdBy', 'fileName', 'createOn'];
    public fileDetailsTableData: BehaviorSubject<TableData[]> = new BehaviorSubject([]);

    constructor(private store$: Store, private dialogRef: MatDialogRef<DownloadFilesDialogComponent>, private _utils: UtilsService) {}

    private getDownloadableFiles = () => {
        this.store$.dispatch(GetInstanceDownloadableFiles({ instanceId: this.instanceId }));
    };

    closeModal = () => {
        this.dialogRef.close();
    };

    public trackByIndexMethod(index: number): any {
        return index;
    }

    public getfileName = name => {
        let checkSumFileName = name.split('/');
        checkSumFileName = checkSumFileName[checkSumFileName.length - 1];
        return checkSumFileName;
    };

    public downloadCheckSumFile = checkSumObj => {
        const splitFileUri = checkSumObj.fileUri.split('/');
        const url =
            environment.taxilla_api +
            '/process/v1/files?fileUrl=' +
            encodeURIComponent(checkSumObj.fileUri) +
            '&fileName=' +
            encodeURIComponent(splitFileUri[splitFileUri.length - 1]);
        window.open(url, 'target = "_blank"');
    };

    public copyCheckSum = content => {
        const fileInput = document.createElement('input');
        fileInput.setAttribute('value', content);
        document.body.appendChild(fileInput);
        fileInput.select();
        document.execCommand('copy');
        document.body.removeChild(fileInput);
        this._utils.alertSuccess(translate('Copied to clipboard'));
    };

    ngOnInit(): void {
        this.recordActions.push({
            displayName: 'Checksum',
            iconName: 'assignment',
            onActionTrigger: this.copyCheckSum,
        });

        this.store$
            .select(getInstanceDownloadableFiles$)
            .pipe(
                takeUntil(this.unSubscribe),
                filter(data => data !== undefined)
            )
            .subscribe((data: any) => {
                const files = CommonUtilsService.cloneObject(data?.[this.instanceId] || []);
                for (let i = 0; i < files.length; i++) {
                    const dateObj = files[i];
                    dateObj['fileName'] = this.getfileName(dateObj.fileUri);
                    if (dateObj && dateObj.createOn) {
                        dateObj.createOn = this._utils.transformDateToLocale(
                            dateObj.createOn,
                            'YYYY-MM-DDTHH:MM:SSZ',
                            'ddMMMyyyy HH:MM:SS AM',
                            false
                        );
                    }
                }
                this.fileDetailsTableData.next(files);
            });

        this.getDownloadableFiles();
    }

    ngOnDestroy(): void {
        this.unSubscribe.next();
        this.unSubscribe.complete();
    }
}
